import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-configurations',
    templateUrl: './configurations.component.html',
    styleUrls: ['./configurations.component.scss'],
    standalone: false
})
export class ConfigurationsComponent implements OnInit {
  constructor(
  ) {  }

  ngOnInit(): void {
  }

}
